import { Box, CircularProgress, LinearProgress, Typography } from "@mui/material";
export function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary' }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

export function CircularProgressWithLabel(props) {
  const { value = 0 } = props;

  return (
    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {/* Фоновый круг (отображается всегда) */}
      <CircularProgress 
        variant="determinate" 
        value={100}
        size={60}
        thickness={4}

        sx={{
          color: "#a0cfca", // цвет фона
        }}
      />
      
      {/* Прогресс круг (отображается поверх фонового) */}
      {value > 0 && (
        <CircularProgress 
          variant="determinate" 
          value={value}
          size={60}
          thickness={4}
          sx={{
            position: 'absolute',
            color: (theme) => theme.palette.primary.main, // цвет прогресса
          }}
        />
      )}
      
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Белый круг */}
        <Box
          sx={{
            position: 'absolute',
            width: '55px',
            height: '55px',
            borderRadius: '50%',
            backgroundColor: 'white',
            zIndex: 1,
          }}
        />
        {/* Текст поверх белого круга */}
        <Typography
          variant="caption"
          component="div"
          sx={{ 
            color: 'text.secondary', 
            fontWeight: 'bold',
            zIndex: 1,
            position: 'relative'
          }}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}